/* @flow */

import is from 'is_js';
// $FlowFixMe
import { isValidPhoneNumber } from 'react-phone-number-input';

import regrex from './regrex';
import { getLabel } from './i18n';
import { formatNumber } from './number';
import API_PATH from '../actions/actionsFactory/apiPath';
import { gwGet } from '../actions/actionsFactory/gwRequest';

const { GET_AGENT_ID_INFO } = API_PATH;

export const errorMsg = {
  email: {
    required: 'exchange-validate-requiredEmail',
    invalid: 'exchange-validate-invalidEmail',
  },
  password: {
    required: 'exchange-validate-requiredPassword',
    invalid: 'exchange-validate-passwordInvalid',
  },
  oldPassword: {
    required: 'exchange-validate-requiredOldPassword',
  },
  confirmPassword: {
    required: 'exchange-validate-requiredConfirmPassword',
    invalid: 'exchange-validate-invalidConfirmPassword',
  },
  agentId: {
    invalid: 'exchange-validate-enterCorrectID',
  },
  agreement: {
    required: 'exchange-validate-pleaseAgreeTerms',
  },
  reCaptcha: {
    required: 'Please check reCaptcha',
  },
  smsCode: {
    required: 'exchange-validate-smsCodeRequire',
    invalid: 'Please enter correct SMS authentication code',
  },
  googleCode: {
    required: 'exchange-validate-googleAuthCodeRequire',
    invalid: 'Please enter correct google authentication code',
  },
  api: {
    required: 'exchange-validate-requiredApiName',
    invalid: 'exchange-validate-invalidApiName',
  },
  withdrawAmount: {
    required: 'exchange-validate-requireAmout',
    invalid: 'exchange-validate-invalidAmount',
    ltbalance: 'exchange-validate-ltbalance',
    ltWithdrawLimit: 'exchange-validate-ltWithdrawLimit',
    stDebit: 'exchange-validate-withdrawStDebit',
  },
  amount: {
    required: 'exchange-validate-requireamount',
    invalid: 'exchange-validate-validamount',
    ltbalance: 'exchange-validate-ltbalance',
    lt8Decimal: 'exchange-validate-lt8Decimal',
    ltBorrowLimit: 'exchange-validate-ltBorrowLimit',
    stDebit: 'exchange-validate-stDebit',
    ltTotalDebit: 'exchange-validate-ltTotalDebit',
    stMaxRepay: 'exchange-validate-stMaxRepay',
    stMinRepay: 'exchange-validate-stMinRepay',
  },
  mobile: {
    required: 'exchange-validate-mobileRequired',
    invalid: 'exchange-validate-mobileInvalid',
  },
  asset: {
    required: 'exchange-validate-requireAsset',
  },
  addressName: {
    required: 'exchange-validate-addressNameRequire',
    invalid: 'exchange-validate-addressNameInvalid',
  },
  address: {
    required: 'exchange-validate-addressRequire',
    invalid: 'exchange-validate-addressInvalid',
  },
  addressTag: {
    required: 'exchange-validate-addressTagRequire',
  },
  ip: {
    required: 'Please enter a IP address.',
    invalid: 'Please enter a correct IP address.',
  },
  firstName: {
    required: 'exchange-validate-requiredFirstName',
  },
  lastName: {
    required: 'exchange-validate-requireLastName',
  },
  birthDay: {
    required: 'exchange-validate-requireBirthDay',
  },
  postalCode: {
    required: 'exchange-validate-requirePostalCode',
  },
  city: {
    required: 'exchange-validate-requireCity',
  },
  country: {
    required: 'exchange-validate-requireCountry',
  },
  applicantName: {
    required: 'exchange-validate-requireApplicantName',
  },
  companyName: {
    required: 'exchange-validate-requireCompanyName',
  },
  companyRegisteredCountry: {
    required: 'exchange-validate-requireCompanyRegisteredCountry',
  },
  contactNumber: {
    required: 'exchange-validate-requireContactNumber',
  },
};

const getScore = (str: string) => {
  let numberLen = 0;
  let lowercaseLen = 0;
  let upperCaseLen = 0;
  let specialCharactersLen = 0;
  let score = 0;
  const { length } = str;
  if (length >= 8 && length < 12) {
    score += 10;
  }
  if (length >= 12 && length < 16) {
    score += 20;
  }
  if (length >= 16) {
    score += 30;
  }
  str.split('').forEach(item => {
    if (/[0-9]/.test(item)) {
      numberLen++;
    } else if (/[a-z]/.test(item)) {
      lowercaseLen++;
    } else if (/[A-Z]/.test(item)) {
      upperCaseLen++;
    } else {
      specialCharactersLen++;
    }
  });
  if (numberLen === 2) {
    score += 10;
  }
  if (numberLen >= 3) {
    score += 20;
  }
  if (specialCharactersLen === 1) {
    score += 10;
  }
  if (specialCharactersLen >= 2) {
    score += 25;
  }
  if (numberLen > 0 && lowercaseLen > 0 && upperCaseLen > 0 && specialCharactersLen > 0) {
    score += 10;
  }
  if (lowercaseLen === 0 && upperCaseLen >= 1) {
    score += 5;
  }
  if (lowercaseLen >= 1 && upperCaseLen >= 1) {
    score += 15;
  }
  return score;
};

export const checkPasswordLevel = (pwd: string) => {
  const score = getScore(pwd);
  if (score >= 15 && score <= 35) return 'low';
  if (score >= 36 && score <= 60) return 'medium';
  if (score >= 61 && score <= 100) return 'high';
  return '';
};

export const checkInput = (inputName: string, value: string, i18n: Object, callback: Function) => {
  const {
    [inputName]: { required: REQUIRED_MSG, invalid: INVALID_MSG },
  } = errorMsg;
  const partten = regrex[inputName];
  if (is.empty(value)) {
    callback(getLabel(REQUIRED_MSG, i18n));
    return false;
  }
  if (!partten.test(value)) {
    callback(getLabel(INVALID_MSG, i18n));
    return false;
  }
  callback('');
  return true;
};

export const checkAgentIdByApi = async (agentId: string) => {
  const result = await gwGet(`${GET_AGENT_ID_INFO}?agentId=${agentId}`, null, null, false);
  if (result.success) {
    const { exist, verified } = result.data;
    return exist && verified;
  }
  return result.success;
};

export const checkAgentId = async (value: string, i18n: Object, callback: Function) => {
  const {
    agentId: { invalid: INVALID_MSG },
  } = errorMsg;
  const partten = regrex.userId;
  if (!is.empty(value)) {
    if (!partten.test(value)) {
      callback(getLabel(INVALID_MSG, i18n));
      return false;
    }
    const isAgent = await checkAgentIdByApi(value);
    if (!isAgent) {
      callback(getLabel(INVALID_MSG, i18n));
      return false;
    }
  }
  callback('');
  return true;
};

export const isTrue = (inputName: string, value: any, i18n: Object, callback: Function) => {
  const {
    [inputName]: { required: REQUIRED_MSG },
  } = errorMsg;
  if (!value) {
    callback(getLabel(REQUIRED_MSG, i18n));
    return false;
  }
  callback('');
  return true;
};

export const checkPhoneNumber = (value: string, i18n: Object, callback: Function) => {
  const {
    mobile: { required: REQUIRED_MSG, invalid: INVALID_MSG },
  } = errorMsg;
  if (!value) {
    callback(getLabel(REQUIRED_MSG, i18n));
    return false;
  }
  if (!isValidPhoneNumber(value)) {
    callback(getLabel(INVALID_MSG, i18n));
    return false;
  }
  callback('');
  return true;
};

export const checkApiName = (value: string, i18n: Object, callback: Function) => {
  const {
    api: { required: REQUIRED_MSG, invalid: INVALID_MSG },
  } = errorMsg;
  const partten = regrex.specialCode;
  if (is.empty(value)) {
    callback(getLabel(REQUIRED_MSG, i18n));
    return false;
  }
  if (partten.test(value)) {
    callback(getLabel(INVALID_MSG, i18n));
    return false;
  }
  return true;
};

export const amountValidate = (value: string, fields: Array<Object>, i18n: {}, ...rest: Array<any>) => {
  for (let i = 0; i < fields.length; i++) {
    const { validate, errorKey, formatter } = fields[i];
    if (!validate(value, ...rest)) {
      let error = errorMsg.amount[errorKey];
      error = getLabel(error, i18n);
      if (formatter) {
        error = formatter(error, ...rest);
      }
      return {
        validate: false,
        errorMsg: error,
      };
    }
  }
  return { validate: true, errorMsg: '' };
};

export const checkAddress = (value: string, regEx: string, i18n: Object, callback: Function) => {
  const {
    address: {
      required: REQUIRED_MSG,
      invalid: INVALID_MSG,
    },
  } = errorMsg;
  const partten = new RegExp(regEx);
  if (is.empty(value)) {
    callback(getLabel(REQUIRED_MSG, i18n));
    return false;
  }
  if (!partten.test(value)) {
    callback(getLabel(INVALID_MSG, i18n));
    return false;
  }
  callback('');
  return true;
};

export const checkWithdrawAmount = (value: string, assetInfo: Object, limitAmount: number, i18n: Object, callback: Function) => {
  const {
    withdrawAmount: {
      required: REQUIRED_MSG,
      invalid: INVALID_MSG,
      ltbalance: LT_BALANCE_MSG,
      ltWithdrawLimit: LT_WITHDRAW_LIMIT_MSG,
      stDebit: ST_DEBIT_MSG,
    },
  } = errorMsg;
  const {
    tick, free, minProductWithdraw, trading,
  } = assetInfo;
  const partten = tick === 0 ? /^[1-9]\d*$/ : new RegExp(`^(([1-9]\\d{0,9})|0)(\\.\\d{1,${tick}})?$`);
  if (is.empty(value)) {
    callback(getLabel(REQUIRED_MSG, i18n));
    return false;
  }
  if (!partten.test(value)) {
    callback(getLabel(INVALID_MSG, i18n).replace('##', tick));
    return false;
  }
  if (Number(value) < Number(minProductWithdraw)) {
    callback(getLabel(ST_DEBIT_MSG, i18n).replace('##', formatNumber(minProductWithdraw, tick)));
    return false;
  }
  if (Number(value) > Number(free)) {
    callback(getLabel(LT_BALANCE_MSG, i18n));
    return false;
  }
  if (Number(value) > Number(limitAmount) && trading) {
    callback(getLabel(LT_WITHDRAW_LIMIT_MSG, i18n));
    return false;
  }
  callback('');
  return true;
};

export const checkConfirmPassword = (confirmPassword: string, password: string, i18n: Object, callback: Function) => {
  const {
    confirmPassword: {
      required: REQUIRED_MSG,
      invalid: INVALID_MSG,
    },
  } = errorMsg;
  if (is.empty(confirmPassword)) {
    callback(getLabel(REQUIRED_MSG, i18n));
    return false;
  }
  if (confirmPassword !== password) {
    callback(getLabel(INVALID_MSG, i18n));
    return false;
  }
  callback('');
  return true;
};


export default {
  checkInput,
  checkAgentId,
  checkAgentIdByApi,
  isTrue,
  checkPasswordLevel,
};
